/** Module flags the server reports in /me (internal/platform/features). */
export const features = {
  collaboration: 'collaboration',
} as const;
